import React, { useCallback } from "react";
import "./index.scss";

export interface CustomArrowProps {
  direction: "previous" | "next";
  onClick?: () => void;
  className?: string;
  isDisabled?: boolean;
}

const CustomArrow = ({
  direction,
  onClick,
  className,
  isDisabled = false,
}: CustomArrowProps) => {
  const icon = `cnh-chevron-${direction === "previous" ? "left" : "right"}`;

  const handleClick = useCallback(() => {
    if (isDisabled) return;
    onClick && onClick();
  }, [isDisabled]);

  return (
    <button
      className={`custom-arrow
       custom-arrow--${direction === "previous" ? "left" : "right"} ${
        isDisabled ? "custom-arrow--disabled" : ""
      } ${className !== "" ? className : ""}`}
      aria-label={`${direction}slide / item`}
      type="button"
      onClick={handleClick}
    >
      <pfe-icon
        icon={icon}
        color={"complement"}
        size="md"
        class={"custom-arrow__icon"}
      />
    </button>
  );
};

export default CustomArrow;
